import { Adtrgtng } from './interfaces'
import { getTargetingData, setTargetingData } from './targeting-data'

/**
 * Gets the UPP targeting data from the targeting cookie. See https://mam-confluence.1and1.com/spaces/TAM/pages/437235764/Concept+Advertising-Cookie#id-%5BConcept%5DAdvertisingCookie-%22u%22
 */
export function getUppTargetingData(): Adtrgtng['u'] {
  const targetingData = getTargetingData()
  return targetingData?.u || {}
}

/**
 * Sets the UPP targeting data in the targeting cookie. Existing data will be overwritten.
 * @param uppData
 * @param cookieTtlHours Optional TTL for the targeting cookie in hours. Defaults to 1 hour.
 */
export function setUppTargetingData(uppData: Adtrgtng['u'], cookieTtlHours?: number): void {
  const targetingData = getTargetingData() || {}
  targetingData.u = uppData
  setTargetingData(targetingData, cookieTtlHours)
}
